import styled from 'styled-components';

import { FacebookButton } from '../FacebookButton';

export const MyIonSigningSigningupButton = styled(FacebookButton)`
  --background-hover: var(--ion-color-primary-shade);
  --ripple-color: var(--ion-color-primary);
  margin-bottom: 20px;
`;
